import * as AccordionPrimitive from '@radix-ui/react-accordion';
import { ChevronDownIcon } from 'lucide-react';
import React from 'react';

import { cn } from '@/lib/utils';

export const AccordionItem = React.forwardRef<
    React.ElementRef<typeof AccordionPrimitive.Item>,
    React.ComponentPropsWithRef<typeof AccordionPrimitive.Item>
>(({ className, ...props }, ref) => (
    // ensure the item can shrink when placed inside flex containers
    <AccordionPrimitive.Item ref={ref} className={cn('min-h-0', className)} {...props} />
));
AccordionItem.displayName = 'AccordionItem';

export const AccordionTrigger = React.forwardRef<
    React.ElementRef<typeof AccordionPrimitive.Trigger>,
    React.ComponentPropsWithRef<typeof AccordionPrimitive.Trigger>
>(({ children, className, ...props }, forwardedRef) => (
    <AccordionPrimitive.Header className="flex">
        <AccordionPrimitive.Trigger
            className={cn(
                'group flex',
                'justify-between flex-1 cursor-default items-center',
                'leading-none outline-hidden',
                className,
            )}
            {...props}
            ref={forwardedRef}
        >
            {children}
            <ChevronDownIcon
                className="h-5 w-5 transition-transform duration-300 ease-[cubic-bezier(0.87,0,0.13,1)] group-data-[state=open]:rotate-180"
                aria-hidden
            />
        </AccordionPrimitive.Trigger>
    </AccordionPrimitive.Header>
));

AccordionTrigger.displayName = 'AccordionTrigger';

export const AccordionContent = React.forwardRef<
    React.ElementRef<typeof AccordionPrimitive.Content>,
    React.ComponentPropsWithRef<typeof AccordionPrimitive.Content>
>(({ children, className, ...props }, forwardedRef) => (
    <AccordionPrimitive.Content
        className={cn(
            'data-[state=closed]:animate-slideUp data-[state=open]:animate-slideDown overflow-hidden',
            className,
        )}
        {...props}
        ref={forwardedRef}
    >
        {children}
    </AccordionPrimitive.Content>
));
AccordionContent.displayName = 'AccordionContent';

export const Accordion = AccordionPrimitive.Root;
